import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Login from './pages/auth/Login';
import Layout from './components/Layout';
import Enquiries from './pages/enquiry/Enquiries';
import AboutImages from './pages/about/AboutImages';
import AddAboutImage from './pages/about/AddAboutImage';
import ResultImages from './pages/results/ResultImages';
import AddResultImage from './pages/results/AddResultImage';
import Events from './pages/events/Events';
import AddEvent from './pages/events/AddEvent';
import StudentLife from './pages/studentLife/StudentLife';
import AddStudentLife from './pages/studentLife/AddStudentLife';
import User from './pages/user/User';
import AddUser from './pages/user/AddUser';
import EventsImages from './pages/events/EventsImages';
import StudentLifeImages from './pages/studentLife/StudentLifeImages';
import { useEffect } from 'react';
import { refreshToken } from './store/thunks/authThunks';
import UserProfile from './pages/user/UserProfile';
import Notification from './pages/notification/Notification';

function App() {
  const { isAuthenticated, user } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    let tokenData = localStorage.getItem('token');
    
    if(tokenData){
      tokenData = JSON.parse(tokenData).token;
    }
    
    if(!isAuthenticated && tokenData){
      dispatch(refreshToken({}));
    }    
  }, []);
  
  // Protected route component
  const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    
    // If allowedRoles is empty or user role is included in allowedRoles
    if (allowedRoles.length === 0 || allowedRoles.includes(user?.role)) {
      return children;
    }
    
    // If user doesn't have required role, redirect to dashboard
    return <Navigate to="/enquiries" />;
  };

  return (
    <Routes>
        <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/enquiries" />} />
        
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/enquiries" replace />} />
          {/* <Route path="dashboard" element={<Dashboard />} /> */}
          <Route path="enquiries" element={<Enquiries />} />
          
          <Route path="about-images">
            <Route index element={<AboutImages />} />
            <Route path="add" element={<AddAboutImage />} />
          </Route>
          
          <Route path="result-images">
            <Route index element={<ResultImages />} />
            <Route path="add" element={<AddResultImage />} />
          </Route>
          
          <Route path="events">
            <Route index element={<Events />} />
            <Route path="add-images" element={<AddEvent />} />
            <Route path="images/:id/:title" element={<EventsImages />} />
          </Route>
          
          <Route path="student-life">
            <Route index element={<StudentLife />} />
            <Route path="add-images" element={<AddStudentLife />} />
            <Route path="images/:id/:title" element={<StudentLifeImages />} />
          </Route>

          <Route path="notification">
            <Route index element={<Notification />} />
          </Route>
          
          <Route path="user">
            <Route index element={<User />} />
            <Route path="add" element={
              <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                <AddUser />
              </ProtectedRoute>
            } />
            <Route path="profile" element={<UserProfile />} />
          </Route>          
        </Route>
        
        {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  );
}

export default App;
